import * as types from './types';

export const INITIAL_STATE = {
  lassoMode: false,
  blockOnClick: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.TOGGLE_LASSO:
      return {
        ...state,
        lassoMode: !state.lassoMode,
      };
    case types.TOGGLE_BLOCK_ON_CLICK:
      return {
        ...state,
        blockOnClick: !state.blockOnClick,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/Components/LassoSelection/state/reducer.js